// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
export class CanvasDrawer {
    constructor() {
        this._isDirty = true;
    }
    isDirty() {
        return this._isDirty;
    }
    setIsDirty() {
        this._isDirty = true;
    }
    setIsNotDirty() {
        this._isDirty = false;
    }
}
